import { Component, OnInit, ViewChild } from "@angular/core";
import { CatalogoService } from "../../../../services/catalogo.service";
import { Catalogo } from "../../../../models/entities/catalogo";
import { ObrasControlService } from "../../../../services/obras-control.service";
import { Alert } from "../../../../models/alert";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ElementoCatalogo } from "../../../../models/entities/elemento-catalogo";
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { AlertasService } from "src/app/services/alertas.service";

export interface controlObras {
  inversionTotal?: string;
  key?: string;
  metaTotal?: string;
  tipoObra?: string;
  totalCompromiso?: string;
  totalConago?: string;
  totalFonadin?: string;
  totalObras?: string;
  totalPrioritarias?: string;
}
@Component({
  selector: "administrar-obras-control",
  templateUrl: "./administrar-obras-control.component.html",
  styleUrls: ["./administrar-obras-control.component.scss"],
})
export class AdministrarObrasControlComponent implements OnInit {
  @ViewChild("modalEdicion")
  public modalEdicion: any;
  public modalActivoEdicion: NgbModalRef;

  public catalogoPrioridades: any[] = [];
  public catalogoDireccionAdjunta: any[] = [];
  forma: FormGroup;
  alert: Alert = new Alert();
  public infoControlObras: any[] = [];

  public keyControlObra: string;

  public edicionForm: FormGroup;

  public refModalActivo: NgbModalRef;

  @ViewChild("modalEliminacion")
  public modalEliminacion: any;

  constructor(
    public catalogoService: CatalogoService,
    public controlService: ObrasControlService,
    private ngbModalService: NgbModal
  ) {
    this.inicializarForm();
  }

  ngOnInit() {
    this.obtenerPrioridar();
    this.obtenerDireccionAdjunta();
    this.obtenerCatalogos();
  }

  obtenerPrioridar() {
    this.catalogoService
      .obtenerCatalogo("catTipoPrioridad")
      .subscribe((data: Catalogo[]) => (this.catalogoPrioridades = data));
  }

  obtenerDireccionAdjunta() {
    this.catalogoService
      .obtenerCatalogo("catDireccionAdjunta")
      .subscribe((data: Catalogo[]) => (this.catalogoDireccionAdjunta = data));
  }

  inicializarForm() {
    this.forma = new FormGroup({
      tipoObra: new FormControl("-1", [Validators.required, this.validarId]),
      totalObras: new FormControl("0", [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      totalPrioritarias: new FormControl("0", [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      totalCompromiso: new FormControl("0", [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      totalConago: new FormControl("0", [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      totalFonadin: new FormControl("0", [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      metaTotal: new FormControl("0", [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      inversionTotal: new FormControl("0", [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
    });
  }

  validarId(control: AbstractControl) {
    return control.value === "-1" ? { error: "El campo es requerido" } : null;
  }

  guardarControl() {
    console.log(this.forma.value);
    console.log(this.forma);
    this.alert.cargando();

    this.controlService.save(this.forma.value).then(
      () => {
        console.log("Registro guardado!");
        this.alert.correcto();
        this.obtenerCatalogos();
      },
      (error) => {
        console.error(error);
        this.alert.error();
      }
    );
  }
  actualizarControl() {
    let edicion = this.edicionForm.value;
    this.alert.cargando();
    delete edicion.key;
    this.controlService.updateControlObra(this.keyControlObra, edicion).then(
      () => {
        this.alert.correcto();
        this.obtenerCatalogos();
        this.cerraModalEdicion();
      },
      (error) => {
        this.alert.error();
      }
    );
  }

  public obtenerMensajeValidacion(controlName: string): string {
    let error = "";
    const control = this.forma.get(controlName);
    if (
      (control.touched && control.errors != null) ||
      (control.touched && control.value === "-1")
    ) {
      error = "El campo es requerido";
    }
    return error;
  }

  public obtenerCatalogos() {
    this.controlService
      .obtenerObrasControl()
      .subscribe((data) => (this.infoControlObras = data));
  }

  public abrirModalEdicion(controlObra: controlObras) {
    this.keyControlObra = controlObra.key;
    this.edicionForm = new FormGroup({
      tipoObra: new FormControl(controlObra.tipoObra, [
        Validators.required,
        this.validarId,
      ]),
      totalObras: new FormControl(controlObra.totalObras, [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      totalPrioritarias: new FormControl(controlObra.totalPrioritarias, [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      totalCompromiso: new FormControl(controlObra.totalCompromiso, [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      totalConago: new FormControl(controlObra.totalConago, [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      totalFonadin: new FormControl(controlObra.totalFonadin, [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      metaTotal: new FormControl(controlObra.metaTotal, [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
      inversionTotal: new FormControl(controlObra.inversionTotal, [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
      ]),
    });
    this.modalActivoEdicion = this.ngbModalService.open(this.modalEdicion, {
      centered: true,
      windowClass: "modal-confirmacion",
      size: "lg",
    });
  }

  public cerraModalEdicion() {
    this.modalActivoEdicion.close();
  }

  eliminacionControl() {
    console.log(this.keyControlObra);
    this.controlService.delete(this.keyControlObra).then(
      () => {
        this.refModalActivo.close();
        this.alert.eliminar();
        this.obtenerCatalogos();

      },
      (error) => {
        this.alert.error();
      }
    );
  }

  public abrirModalEliminacion(controlObra: controlObras) {
    this.keyControlObra = controlObra.key;
    this.refModalActivo = this.ngbModalService.open(this.modalEliminacion, {
      centered: true,
      windowClass: "modal-confirmacion",
      backdrop: "static",
      keyboard: false,
    });
  }
}
